import { Decoration, WidgetType } from "@codemirror/view";
import { hiddenDecoration, shouldHideMarkers } from "../utils/decorationHelper";

const horizontalRuleWidget = Decoration.widget({
  widget: new class extends WidgetType {
    toDOM() {
      const hr = document.createElement("hr");
      hr.className = "cm-markdoc-hr";
      return hr;
    }
  }(),
});

export function decorateHorizontalRule(node, view, widgets, mode) {
  if (node.from >= node.to) return false;

  if (shouldHideMarkers(view, node, mode)) {
    widgets.push(horizontalRuleWidget.range(node.from));
    widgets.push(hiddenDecoration(node.from, node.to));
  }

  return false; // Prevent further processing
}
